import { createContext } from "react";

const ServicesContext = createContext();
export default ServicesContext;
